import EN from './EN';
import TR from './TR';
import RO from './RO';
import DE from './DE';
import GR from './GR';
import AR from './AR';

export default { EN, TR, RO, DE, GR, AR };
